const formattedTimer = (time) => {

    const seconds = (time % 60).toString().padStart(2, '0')
    const minutes = (Math.trunc(time / 60)).toString().padStart(2, '0')

    return `${minutes}:${seconds}`

}

const maskedPhoneNumber = number => {
    const pureNumber = String(number)
    // return pureNumber.slice(0, 4) + '****' + pureNumber.slice(8); // 362****0903 (because of persian num font i believe)
    return (pureNumber.slice(0, 4) + " " + '****' + " " + pureNumber.slice(8)).split(' ').reverse().join(' ').replaceAll(' ', ''); // right one for persian nums
}

const debounce = (func, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        if (func) {
            timer = setTimeout(() => func(...args), delay);
        }
    };
};

export {
    formattedTimer,
    maskedPhoneNumber,
    debounce,

}